import { type HTMLAttributes, createContext, useContext } from 'react';

type Props = HTMLAttributes<HTMLFieldSetElement> & {
    name: string;
};

function RadioGroup({ name, children, ...props }: Props) {
    return (
        <RadioGroupContext.Provider value={{ name }}>
            <fieldset {...props}>{children}</fieldset>
        </RadioGroupContext.Provider>
    );
}

type ContextProps = {
    name: string;
};
const RadioGroupContext = createContext<ContextProps>({} as ContextProps);

type RadioProps = {
    value: string;
    classes?: { root?: string; label?: string; input?: string };
    defaultChecked?: boolean;
};
const Radio = ({ value, classes, defaultChecked }: RadioProps) => {
    const { name } = useContext(RadioGroupContext);

    return (
        <div className={classes?.root}>
            <label htmlFor={value} className={classes?.label}>
                {value}
            </label>
            <input
                type="radio"
                className={classes?.input}
                value={value}
                name={name}
                id={value}
                defaultChecked={defaultChecked}
            />
        </div>
    );
};

RadioGroup.Radio = Radio;

export default RadioGroup;
